/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from '@insticator/insticator-ui';


/* ++++++++++ --------------- CONFIGURATION PAGE - ENGAGEMENT : STYLES --------------- ++++++++++ */
export default {
  advanced: {},
};
